import { createFileRoute } from '@tanstack/react-router';
import { WorkflowsList } from '@/components/pages/WorkflowsList';

export const Route = createFileRoute('/workflows')({
  component: WorkflowsList,
});
